import { IApplicationState } from '../../types/redux';

export function selectUserStatus(state: IApplicationState) {
  return state.user.status;
}
